import { realData } from "./gameData";
import { startGame } from "./game/startGame";
import { expectEl } from "./util";

import "./styles/index.scss";

function main() {
    const startMenuEl = expectEl(".startMenu");
    const startBtnEl = expectEl(".startBtn", startMenuEl);
    startBtnEl.onclick = () => {
        startMenuEl.classList.add("--hidden");
        expectEl("#game").classList.remove("--hidden");
        startGame(realData);
    };
}

window.onload = main;
